import React, {Component} from 'react'
import {Button, Header, Input, Modal} from 'semantic-ui-react'

export default class UnregisterRegularPlayerModal extends Component {

    state = {};

    handleClick = (ev, data) => this.setState({chosenPlayer: data.player});

    setBeers = (ev, data) => {
        this.setState({boughtBeerCount: data.value});
    };

    setComment = (ev, data) => {
        this.setState({comment: data.value});
    };

    handleSubmit = () => this.props.registerBoughtBeers(
        this.state.chosenPlayer.id, this.state.boughtBeerCount, this.state.comment);

    render() {
        const playerOptions = this.props.players
            .map(player =>
                <Button
                    key={player.id}
                    onClick={this.handleClick}
                    player={player}
                    inverted color='red'
                    content={player.name}/>);

        return (
            <Modal
                open={this.props.open}
                basic
                size='small'
                closeOnEscape={true}
                closeOnDimmerClick={true}
            >
                <Header icon='users' content='Innfri øl'/>
                <Modal.Content>
                    {playerOptions}
                    <br/>
                    <Input icon='beer' placeholder="Hvor mange øl?" onChange={this.setBeers}/>
                    <Input icon='beer' placeholder="Eventuell kommentar?" onChange={this.setComment}/>
                </Modal.Content>
                {this.state.chosenPlayer && this.state.boughtBeerCount ?
                    <Modal.Actions>
                        {this.state.chosenPlayer.name} har kjøpt {this.state.boughtBeerCount}?
                        {<Button inverted onClick={this.handleSubmit} color='green' content='Stemmer'/>}
                    </Modal.Actions>
                    : <Modal.Actions>
                        Hvor mange øl er kjøpt?
                    </Modal.Actions>}
            </Modal>)
    }
}



// WEBPACK FOOTER //
// ./src/Components/RegisterBoughtBeersModal.js